var _defs, _path, _path2, _path3, _path4, _g;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLogotextHorizontal(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 227.99 60.28",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#f0f1f2;}.cls-2{isolation:isolate;}.cls-3{fill:#bcbec0;}"))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Logo text_horizontal") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M0,34.17A26.13,26.13,0,1,0,29.9,8.31a5,5,0,1,0-7.53,0A26.17,26.17,0,0,0,0,34.17H0ZM23.12,5a3,3,0,1,1,3,3,3,3,0,0,1-3-3h0Zm3,5A24.12,24.12,0,1,1,2,34.17,24.12,24.12,0,0,1,26.12,10h0Z",
    transform: "translate(0 -0.02)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M26.17,55.28A21.11,21.11,0,1,0,5,34.17,21.11,21.11,0,0,0,26.17,55.28h0Zm0-40.2a19.1,19.1,0,1,1-19.1,19.1,19.1,19.1,0,0,1,19.1-19.1h0Z",
    transform: "translate(0 -0.02)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M19.66,35.17l-5.49,9.55a1,1,0,0,0,1.37,1.37l9.55-5.46v9.61a1,1,0,0,0,1,1h0a1,1,0,0,0,1-1V39.49l1.84-1,7.81,7.81a1,1,0,0,0,1.41,0h0a1,1,0,0,0,0-1.41h0L30.35,37l1.05-1.84h9.77a1,1,0,0,0,1-1h0a1,1,0,0,0-1-1H32.56L38,23.63a1,1,0,0,0-1.37-1.37L27.17,27.7V18.09a1,1,0,0,0-1-1h0a1,1,0,0,0-1,1V28.85l-1.84,1-7.81-7.81a1,1,0,0,0-1.41,0h0a1,1,0,0,0,0,1.41h0l7.81,7.81-1.1,1.85H11.06a1,1,0,0,0-1,1h0a1,1,0,0,0,1,1h8.6Zm14.82-9.36L28.4,36.44,17.77,42.52l6.08-10.63Z",
    transform: "translate(0 -0.02)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M26.13,32.94h0a1.23,1.23,0,0,1,1.23,1.23h0a1.23,1.23,0,0,1-1.23,1.23h0a1.23,1.23,0,0,1-1.23-1.23h0A1.23,1.23,0,0,1,26.13,32.94Z",
    transform: "translate(0 -0.02)"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "cls-2"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-2"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M103.72,42.51L101.43,37H93.8l-2.38,5.54H87L96,21.07h3.13l9,21.44h-4.38ZM97.54,26.67l-2.29,6.5h4.58Z",
    transform: "translate(0 -0.02)"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-2"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M114,30V42.51h-3.86V30h-1.88V26.44h1.88V21.07H114v5.37h2.32V30H114Z",
    transform: "translate(0 -0.02)"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-2"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M145.7,42.51L134.42,22.9V42.51h-5v-27h5.7l11.17,19.64V15.53h5v27H145.7Z",
    transform: "translate(0 -0.02)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M169.25,43A14.1,14.1,0,0,1,155,28.93a13.92,13.92,0,0,1,13.88-13.88,13.74,13.74,0,0,1,12.78,8.22h-5.59a8.1,8.1,0,0,0-7.08-3.4A8.86,8.86,0,0,0,160.08,29a9.18,9.18,0,0,0,9.06,9.2c2.59,0,4.49-.88,6.68-3.18h5.88A13.32,13.32,0,0,1,169.25,43Z",
    transform: "translate(0 -0.02)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M199.92,41c-2.19,1.1-4.64,1.5-8.73,1.5h-6.28v-27h6.17c4.24,0,7.45.66,9.57,1.94,3.76,2.26,5.88,6.5,5.88,11.61C206.52,34.51,204.08,39,199.92,41ZM197.36,21.4c-1.57-.8-3.29-1.1-6.46-1.1h-1V37.73H191c3,0,5.08-.37,6.57-1.21a8.33,8.33,0,0,0,3.91-7.45C201.49,25.6,199.92,22.72,197.36,21.4Z",
    transform: "translate(0 -0.02)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M217.66,42.51h-7.19v-27H216c4,0,5.7.29,7.3,1.31a6.78,6.78,0,0,1,3.07,5.88,5,5,0,0,1-3,5.08c3.43,1.42,4.6,3.47,4.6,6.68C228,39.41,224.6,42.51,217.66,42.51Zm-0.15-22.09h-2v5.51h1.61c3,0,4.31-.84,4.31-2.78S220.1,20.42,217.51,20.42Zm0.33,10.41h-2.37v6.9H218c3.5,0,5-1,5-3.36S221.31,30.83,217.84,30.83Z",
    transform: "translate(0 -0.02)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogotextHorizontal);
export default __webpack_public_path__ + "static/media/Logo text_horizontal.889d60b2.svg";
export { ForwardRef as ReactComponent };